// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fr-field-error[data-v-b0cee7c2]{color:#000;border:1px solid #f1ced5;border-radius:4px;background-color:hsla(0,0%,100%,.8);display:flex;align-items:center;padding:6px}.fr-phone .fr-field-error[data-v-b0cee7c2]{margin-top:5px}:is(#totally-fake-specificity-id[data-v-b0cee7c2],.fr-field-error[data-v-b0cee7c2]){color:#000!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
